import styled from 'styled-components'
import { IStyleElement } from '~/types/types'
import { COLORS } from './Constants'

const StyledLink = styled.a<{hover?: boolean} & IStyleElement>`
  text-decoration: none !important;
  :hover {
    cursor: pointer;
    p {
      color: ${COLORS.PRIMARY};
      opacity: 1;
    }
  }
`
const Link = (props: any & IStyleElement) => <StyledLink {...props} rel='noopener noreferrer' />

export default Link